import { isValid, parseISO } from 'date-fns'

/**
 * @param birthday
 * @returns
 */
export const calculateAge = (birthday: string) => {
    const [year, month, day] = birthday.split('-').map(Number)
    const birthDate = new Date(year, month - 1, day)

    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--
    }
    return age
}

export const isUnderAge = (birthday: string, ageLimit: number = 18): boolean => {
    if (!birthday) return false

    const birthDate = parseISO(birthday)
    if (!isValid(birthDate)) return false

    const today = new Date()

    const ageLimitDate = new Date(birthDate)
    ageLimitDate.setFullYear(birthDate.getFullYear() + ageLimit)

    return today < ageLimitDate
}
